import React from 'react';
import cl from './Comparison.module.css';
import { IconCheck } from '../../components/icons';
import useReveal from '../../hooks/useReveal';

// Сравнительная таблица «До / После СтартКласса».
// 8 ключевых строк, по которым проще всего объяснить разницу.
// На мобилке таблица перестраивается в карточки.

const rows = [
    {
        topic: 'Преподаватели',
        before: 'Программист-инженер от 80 000 ₽/мес. Найти сложно, удерживать — ещё сложнее.',
        after:  'Обычный педагог. Технику разучивает за 1–2 недели по нашим курсам.',
    },
    {
        topic: 'Учебная программа',
        before: 'Scratch + Roblox Studio + бумажные методички. Каждый год собираете заново.',
        after:  '35 курсов и 30 000 задач уже готовы. Обновления — без доплат.',
    },
    {
        topic: 'Проверка задач',
        before: 'Преподаватель проверяет всё руками. Время съедает половину занятия.',
        after:  'Автопроверка всех 30 000 задач прямо в браузере. Подсказки — встроенные.',
    },
    {
        topic: 'Группы и расписание',
        before: 'Дети разной скорости тормозят группу. Болезнь = пропуск + отработка.',
        after:  'Каждый идёт в своём темпе. Новичка можно записать в любой момент.',
    },
    {
        topic: 'ПО на компьютеры',
        before: 'Scratch.app, Roblox Studio, Python, IDE — ставить и обновлять на каждый ноут.',
        after:  'Всё работает в браузере. Подойдут даже старые ноутбуки с Авито.',
    },
    {
        topic: 'Журнал и отчётность',
        before: 'Excel + Telegram + бумажные тетради. Сводить вручную каждый месяц.',
        after:  'АдминПанель: посещения, оплаты, дашборд, прогресс — в одном окне.',
    },
    {
        topic: 'Мотивация детей',
        before: 'Грамоты в конце года. Дети теряют интерес через 3–4 месяца.',
        after:  'Алмазы, рейтинг, Битва рейтингов, робокоины — мотивация на годы.',
    },
    {
        topic: 'Прозрачность для родителей',
        before: '«Расскажите, как мой ребёнок?» — преподаватель пересказывает по памяти.',
        after:  'Родитель видит прогресс, задачи, рейтинг ребёнка в личном кабинете.',
    },
];


export default function Comparison() {
    const revealRef = useReveal();
    return (
        <section className={cl.comp} id="comparison" ref={revealRef}>
            <div className={cl.inner}>
                <div className={cl.head}>
                    <span className={cl.eyebrow} data-reveal="down">До / После</span>
                    <h2 className={cl.title} data-reveal="up" style={{ '--reveal-delay': '100ms' }}>
                        Что меняется <span className={cl.accent}>в центре</span> со СтартКлассом
                    </h2>
                    <p className={cl.subtitle} data-reveal="up" style={{ '--reveal-delay': '180ms' }}>
                        Восемь главных отличий между классическим IT-направлением
                        и работой по нашей системе.
                    </p>
                </div>

                {/* Шапка таблицы — отображается только на десктопе */}
                <div className={cl.tableHead}>
                    <div className={cl.headTopic}></div>
                    <div className={cl.headBefore}>
                        <span className={cl.headLabel}>Без СтартКласса</span>
                    </div>
                    <div className={cl.headAfter}>
                        <span className={cl.headLabel}>Со СтартКлассом</span>
                    </div>
                </div>

                {/* Строки */}
                <div className={cl.list} data-reveal-stagger>
                    {rows.map((r, i) => (
                        <div key={r.topic} className={cl.row}
                            data-reveal={i % 2 === 0 ? 'left' : 'right'}>
                            <div className={cl.topic}>
                                <span className={cl.topicNum}>{i + 1}</span>
                                <span className={cl.topicText}>{r.topic}</span>
                            </div>
                            <div className={cl.before}>
                                <span className={cl.mobileLabel}>Без СтартКласса</span>
                                <div className={cl.cellBody}>
                                    <span className={cl.cross}>×</span>
                                    <span>{r.before}</span>
                                </div>
                            </div>
                            <div className={cl.after}>
                                <span className={cl.mobileLabel}>Со СтартКлассом</span>
                                <div className={cl.cellBody}>
                                    <span className={cl.check}>
                                        <IconCheck width={12} height={12} strokeWidth={3}/>
                                    </span>
                                    <span>{r.after}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
